export const formatDuration = (input) => {
  if (!input) {
    return '';
  }
  const timeValue = parseInt(input, 10);
  const unit = input.slice(-1);

  if (unit === 's') {
    const minutes = timeValue / 60;
    const hours = timeValue / 3600;

    if (hours >= 1) {
      return `${hours.toFixed(2)} hrs`;
    } else if (minutes >= 1) {
      return `${minutes.toFixed(2)} min`;
    } else {
      return `${timeValue} secs`;
    }
  } else {
    throw new Error('Invalid time unit. Only seconds ("s") are supported.');
  }
};
